import { defineQuery, useQuery } from "@pinia/colada";

const siteOptionsParsed = v.safeParse(siteOptionsSchema, site_options);

export const useSiteOptions = defineQuery(() => {
  const { data: siteOptions, isLoading, status } = useQuery<SiteOptions, Error, SiteOptions>({
    key: () => ["site_options"],
    query: async () => v.parse(siteOptionsSchema, await ajaxRequest<SiteOptions>("get_site_options")),
    initialData: siteOptionsParsed.success ? () => siteOptionsParsed.output : undefined,
    enabled: !siteOptionsParsed.success,
    placeholderData: {
      name: "LilloJEUX",
      description: "Boutique québécoise de jeux de société et casse-têtes",
      top_menu_items: [],
      main_menu_items: [],
      footer_menu_items: [],
      contact: {
        address: "596 Boul Perron<br/>Maria (Québec) G0C 1Y0",
        email: "info@lillojeux.ca",
        phone: {
          number: "+14187595389",
          country: "ca",
          national: "(418) 759-5389",
          international: "+1 418-759-5389",
        },
        social_medias: [
          {
            url: "https://www.facebook.com/lillojeux/",
            icon: "facebook",
          },
          {
            url: "https://www.instagram.com/lillojeux/",
            icon: "instagram",
          },
          {
            url: "https://www.tiktok.com/%40lillojeux",
            icon: "tiktok",
          },
        ],
      },
      messages: {
        cart_confirmation: {
          title: "Confirmation d’achat",
          description: "Une fois que vous aurez effectué un achat via le site Web de Lillojeux, vous recevrez un courriel confirmant la réception de votre commande. Il est recommandé de conserver ce courriel à titre de preuve d'achat, car il pourrait vous être demandé en cas de problème.",
        },
        free_shipping: "Livraison gratuite au Québec pour les achats de 79&nbsp;$ et plus!",
      },
      cart_url: "https://www.lillojeux.ca/panier/",
      checkout_url: "https://www.lillojeux.ca/commander/",
      login_url: "https://www.lillojeux.ca/mon-compte/",
      logout_url: "https://www.lillojeux.ca/mon-compte/",
      shipping_url: "https://www.lillojeux.ca/livraison/",
      shop_url: "https://www.lillojeux.ca/boutique/",
      wishlist_url: "https://www.lillojeux.ca/mon-compte/wishlist/",
    },
  });
  return { siteOptions, isLoading, status };
});
